import Alert from '@mui/material/Alert';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { AskAnalyst } from '@/features/desk';
import type { Answer } from '../api/schemas';

type Props = {
  answer: Answer;
  onAsk?: ((question: string) => void) | undefined;
  question: string;
  context: string[];
  deskQuestionId?: string | undefined;
  onDeskAsked?: ((questionId: string) => void) | undefined;
};

/** A refusal that says why, and offers questions the research can answer instead, one click away. */
export function RefusalBody({ answer, onAsk, question, context, deskQuestionId, onDeskAsked }: Props) {
  return (
    <Stack sx={{ gap: 1.5 }}>
      <Alert severity="warning" variant="outlined">
        {answer.text}
        {answer.hint ? (
          <Typography variant="body2" sx={{ mt: 0.75, color: 'text.secondary' }}>{answer.hint}</Typography>
        ) : null}
      </Alert>
      {answer.route === 'unavailable' ? null : <AskAnalyst question={question} context={context} questionId={deskQuestionId} onAsked={onDeskAsked} />}
      {onAsk && answer.followUps.length > 0 ? (
        <Stack direction="row" sx={{ alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>You could ask instead:</Typography>
          {answer.followUps.map((q) => (
            <Chip key={q} label={q} variant="outlined" clickable onClick={() => { onAsk(q); }} />
          ))}
        </Stack>
      ) : null}
    </Stack>
  );
}
